/** @jsxImportSource @emotion/react */
import { BasePage } from 'components';
import { MerchantApplicationProvider } from 'contexts/MerchantApplication.context';
import { SignUpFlow } from 'modules/sign-up';

const SignUpPage = () => {
  return (
    <MerchantApplicationProvider>
      <BasePage title={null} variant="layout" fullWidth>
        <SignUpFlow></SignUpFlow>
      </BasePage>
    </MerchantApplicationProvider>
  );
};

export default SignUpPage;
